import React from 'react';
import PropTypes from 'prop-types';

const Loading = ({ width, height, theme }) => (
  <span 
    data-testid="loading" 
    style={{ width, height }} 
    className={`loading-spinner theme-${theme}`} 
  />
);

Loading.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  theme: PropTypes.string
};

Loading.defaultProps = {
  width: '30px',
  height: '30px',
  theme: 'blue'
};

export default Loading;
